import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';
import Login from '../views/Login';
import Admin from '../layouts/Admin.jsx';
import ForgotPassword from '../views/Authentication/forgotPassword/index'
import React from 'react';
import { Switch, Redirect } from "react-router-dom";
import CableRent from '../views/CableRent.jsx';
import ChargingCode from '../views/ChargingCode.jsx';
import PaymentErrorPage from '../views/PaymentErrorPage.jsx';
import CableStoreOnboard from '../views/CableStoreOnboard';

const Routes = (props) => {
  return (
    <Switch>
      <PublicRoutes
        path="/login"
        component={Login}
        exact={true}
      />
      <PublicRoutes
        path="/ForgotPassword"
        component={ForgotPassword}
        exact={true}
      />
      <PublicRoutes
        path="/"
        component={CableRent}
        exact={true}
      />
      <PrivateRoutes
        path="/admin"
        component={Admin}
      />
      <PublicRoutes
        path="/onboard"
        component={CableStoreOnboard}
        exact={true}
      />
      <PublicRoutes
        path="/passcode"
        component={ChargingCode}
        exact={true}
      />
      <PublicRoutes
        path="/payment-error"
        component={PaymentErrorPage}
        exact={true}
      />
      <Redirect
        from="/"
        to="/login"
      />
      {/* <Redirect
        from="/"
        to="/"
      /> */}
    </Switch>
  )
}

export default Routes;